import { __rest } from "tslib";
import { methods } from './index/methods';
import Vue from 'vue';
import ahead from '@/components/pages/leveragesPage/components/ahead/ahead.vue';
import leverageItem from '@/components/pages/leveragesPage/components/item/index.vue';
import multiSettingLeverages from './components/aside/components/multiSettingLeverages/index.vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import { throttle } from '@/utils/decorators';
import { reducedItems } from './helpers/index';
import { declOfNum } from '@/utils/numbers';
import _ from 'lodash';
import { mapGetters } from 'vuex';
import ReqAfterKyc from './../spotPage/kyc-plugs/RegAfterKyc.vue';
var MarginTypes;
(function (MarginTypes) {
    MarginTypes["cross"] = "cross";
    MarginTypes["isolated"] = "isolated";
})(MarginTypes || (MarginTypes = {}));
let selectedLeveragesFoldersIDs = [];
let selectedFoldersIDs = [];
function mouseMoveAndMouseUpHandler(needThrottle = false) {
    if (!needThrottle) {
        let hoveredFolderID = null;
        const allTargets = document.querySelectorAll('.leverageItem_folderTitle, .leveragesTicker-wrapper--inFolder');
        for (let i = 0; i < allTargets.length; i++) {
            const item = allTargets[i];
            if (selectedLeveragesFoldersIDs.length || selectedFoldersIDs.length) {
                if (item.dataset.type === 'folder' || item.dataset.type === 'item') {
                    if (!selectedLeveragesFoldersIDs.includes(+item.dataset.folderid) && !selectedFoldersIDs.includes(+item.dataset.folderid)) {
                        item.classList.remove(item.dataset.type === 'folder' ? 'leverageItem_folderTitle--manual-hover' : 'leveragesTicker-wrapper--manual-hover');
                    }
                }
            }
            else {
                item.classList.remove('leverageItem_folderTitle--manual-hover');
                item.classList.remove('leveragesTicker-wrapper--manual-hover');
            }
        }
        for (let i = 0; i < allTargets.length; i++) {
            const item = allTargets[i];
            if (item.matches(':hover') && !hoveredFolderID) {
                hoveredFolderID = +item.dataset.folderid;
            }
        }
        for (let i = 0; i < allTargets.length; i++) {
            const item = allTargets[i];
            if (+item.dataset.folderid === hoveredFolderID || selectedLeveragesFoldersIDs.includes(+item.dataset.folderid) || selectedFoldersIDs.includes(+item.dataset.folderid)) {
                if (item.dataset.type === 'item' && !item.classList.contains('leveragesTicker-wrapper--manual-hover'))
                    item.classList.add('leveragesTicker-wrapper--manual-hover');
                if (item.dataset.type === 'folder' && !item.classList.contains('leverageItem_folderTitle--manual-hover')) {
                    item.classList.add('leverageItem_folderTitle--manual-hover');
                }
            }
        }
    }
    else {
        setTimeout(mouseMoveAndMouseUpHandler, 10);
    }
}
function handleChangeLeverageInAsideValue(newValue, oldValue) {
    const condition = this.selectedItems.length === 1 &&
        this.selectedItems[0].id === this.temporaryEditableInAsideLeverage.id &&
        this.selectedItems[0].val !== newValue &&
        newValue !== oldValue;
    if (condition)
        this.setTemporaryLeverage();
}
const debounced = _.debounce(handleChangeLeverageInAsideValue, 1000);
export default Vue.extend({
    name: 'leveragesPageBody',
    data: () => ({
        changeMarginTypeLoader: false,
        asideIsOpened: false,
        searchField: '',
        baseList: [],
        list: [],
        isInited: false,
        xCoordinate: 0,
        yCoordinate: 0,
        foldersContextMenu: false,
        itemsContextMenu: false,
        colWidth: 360,
        haveColumns: 0,
        boxHeight: 0,
        folderMenuInstance: null,
        folderIDToRename: null,
        visibilityAll: true,
        commonChangeLeverageValue: 1,
        deleteFolderDialog: false,
        dragProccess: false,
        selectedMax: null,
        selectedCommonLeveragesMax: undefined,
        newTickerAdded: false,
        collapsedAsideFolders: [],
        marginTypes: {
            cross: 'Кросс',
            isolated: 'Изолированная'
        },
        temporaryEditableInAsideLeverage: {
            name: '',
            id: -1,
            brackets: [],
            value: 1,
            max: 20,
            marginType: 0
        },
        temporaryEditableLeverages: {
            leverageVal: 0,
            marginType: -1
        },
        isRetry: true,
        optimalLeverageLoading: false,
        loadError: false,
        letDeleteInput: '',
        isMultiSelect: false,
        scrollerStepDefinition: {
            dx: 0,
            dy: 0
        },
        scrollerManualPositionDefinition: {
            x: 0,
            y: 0
        },
        automaticLeverage: false,
        tikersIds: [],
        optimalLeveragesPopup: false
    }),
    watch: {
        selectedItems(arr, arrOld) {
            const vm = this;
            const handle = () => {
                setTimeout(() => {
                    if (!vm.newTickerAdded)
                        vm.newTickerAdded = true;
                    setTimeout(() => {
                        if (vm.newTickerAdded)
                            vm.newTickerAdded = false;
                    }, 700);
                }, 10);
            };
            if (arr.length > arrOld.length) {
                if (vm.newTickerAdded) {
                    vm.newTickerAdded = false;
                    handle();
                }
                else {
                    handle();
                }
            }
            if ((!vm.dragProccess && !this.itemsContextMenu) && vm.miw(960)) {
                vm.asideIsOpened = arr.length > 0;
            }
            if (arr.length < 1) {
                vm.visibilityAll = true;
                if (vm.isInited)
                    mouseMoveAndMouseUpHandler(true);
                this.isMultiSelect = false;
            }
            if (arr.length === 1) {
                const selectedItem = vm.selectedItems[0];
                const tempItem = vm.temporaryEditableInAsideLeverage;
                tempItem.brackets = [];
                tempItem.name = selectedItem.name;
                tempItem.value = selectedItem.val;
                tempItem.max = selectedItem.max;
                tempItem.id = selectedItem.id;
                tempItem.marginType = selectedItem.marginType;
                vm.preloadMaxAmount();
                this.$nextTick(() => {
                    setTimeout(() => {
                        if (this.asideIsOpened && this.miw(960) && !this.itemsContextMenu) {
                            const $mainWrapper = document.getElementById('mainWrapper');
                            const $selectedItemNode = document.getElementById('item' + arr[0].name);
                            if ($selectedItemNode && $mainWrapper) {
                                const selectedItemLeftPosition = $selectedItemNode.offsetLeft;
                                const scrollBarLeftPosition = this.$refs.leveragesScrollbar.scrollState.left;
                                if (selectedItemLeftPosition - (this.colWidth * 2) > scrollBarLeftPosition) {
                                    this.scrollerManualPositionDefinition.x = selectedItemLeftPosition - this.colWidth - 16 + Math.random();
                                }
                            }
                        }
                    }, 0);
                });
            }
            vm.baseList.forEach((folder) => {
                folder.haveSelected = Boolean(folder.items.find((item) => {
                    if (!item)
                        console.log(item);
                    return item === null || item === void 0 ? void 0 : item.selected;
                }));
            });
        },
        selectedCommonLeveragesMax(v) {
            if (v) {
                this.commonChangeLeverageValue = 1;
            }
        },
        'temporaryEditableInAsideLeverage.value'(newValue, oldValue) {
            debounced.call(this, newValue, oldValue);
        }
    },
    computed: Object.assign(Object.assign(Object.assign({}, mapGetters('mainPageModules', {
        getFuturesSettings: 'getFuturesSettings'
    })), mapGetters('user', ['extendedKycStatus'])), { isExtendedFailed() {
            return this.extendedKycStatus !== 'accepted' && this.extendedKycStatus !== null;
        }, selectedFolderID() {
            let result = null;
            for (const folder of this.baseList) {
                if (result)
                    continue;
                if (folder.selected)
                    result = folder.id;
            }
            return result;
        },
        defaultFolderIndex() {
            for (const folder of this.baseList) {
                if (folder.default_folder)
                    return folder.index;
            }
            return -1;
        },
        loadingText() {
            if (this.optimalLeverageLoading)
                return 'Выставляем оптимальные плечи';
            return 'Загрузка';
        },
        maxAmountOfLeverage() {
            const vm = this;
            if (vm.temporaryEditableInAsideLeverage.brackets.length) {
                for (const item of vm.temporaryEditableInAsideLeverage.brackets) {
                    if (item.maxValue >= vm.temporaryEditableInAsideLeverage.value)
                        return item.maxAmount;
                }
            }
            return -1;
        }, declOfNum: () => declOfNum, computedList() {
            const vm = this;
            return reducedItems(vm.baseList, vm.visibilityAll, vm.searchField);
        },
        asideTickers() {
            const vm = this;
            const result = [];
            this.computedList.forEach((item) => {
                if (item.type === 'item') {
                    const isCollapsed = Boolean(vm.collapsedAsideFolders.find((id) => id === vm.baseList[item.folderIndex].id));
                    if (item.selected && !isCollapsed) {
                        result.push(item);
                    }
                }
                else {
                    if (item.haveSelected)
                        result.push(item);
                }
            });
            return result;
        },
        asideMessage() {
            const vm = this;
            if (vm.asideIsOpened) {
                if (vm.selectedItems.length <= 1)
                    return vm.$t('leveragesPage.selectMoreThanOne');
                if (!vm.selectedCommonLeveragesMax) {
                    return vm.$t('leveragesPage.selectMaxValue');
                }
                else {
                    const haveCommonTickers = vm.selectedItems.reduce((acc, curr) => {
                        if (curr.max === vm.selectedCommonLeveragesMax)
                            acc += 1;
                        return acc;
                    }, 0);
                    const declOfNumArray = [this.$t('leveragesPage.leverageTypeA'), this.$t('leveragesPage.leverageTypeB'), this.$t('leveragesPage.leverages')];
                    return `${vm.$t('leveragesPage.maxValuePositionSelectedTickers')} <b>${vm.selectedCommonLeveragesMax} </br>${vm.$t('leveragesPage.youEditing')} ${haveCommonTickers} ${declOfNum(haveCommonTickers, declOfNumArray)}</b>`;
                }
            }
            return '';
        },
        letMoveFolderDown() {
            const vm = this;
            return (id) => {
                if (id === 0)
                    return false;
                return vm.baseList.findIndex((item) => item.id === id) < vm.baseList.length - 2;
            };
        },
        letMoveFolderUp() {
            const vm = this;
            return (id) => {
                if (id === 0)
                    return false;
                return vm.baseList.findIndex((item) => item.id === id) > 0;
            };
        },
        selectedItems() {
            const result = [];
            this.baseList.forEach((folder) => {
                result.push(...folder.items.filter((item) => item === null || item === void 0 ? void 0 : item.selected));
            });
            selectedLeveragesFoldersIDs = result.reduce((arr, current) => {
                if (!arr.includes(this.baseList[current.folderIndex].id))
                    arr.push(this.baseList[current.folderIndex].id);
                return arr;
            }, []);
            return result;
        },
        selectedFolders() {
            const result = this.baseList.filter((folder) => folder.selected).map((folder) => {
                return ((_a) => {
                    var { items } = _a, others = __rest(_a, ["items"]);
                    return others;
                })(folder);
            });
            selectedFoldersIDs = result.map((folder) => folder.id);
            return result;
        },
        letDeleteItemFromFolder() {
            return this.selectedItems.findIndex((item) => item.in_default_folder) < 0;
        },
        availableToMoveFolders() {
            const vm = this;
            function availableFolders() {
                return vm.baseList.reduce((arr, curr) => {
                    if (!curr.default_folder && curr.id !== vm.selectedItems[0].folderID)
                        arr.push({ name: curr.name, index: curr.index });
                    return arr;
                }, []);
            }
            if (vm.selectedItems.length)
                return availableFolders();
            return [];
        } }),
    methods,
    beforeDestroy() {
        window.removeEventListener('resize', this.init);
        window.onmousemove = null;
        window.onmouseup = null;
    },
    mounted() {
        const vm = this;
        window.onmousemove = mouseMoveAndMouseUpHandler;
        window.onmouseup = mouseMoveAndMouseUpHandler;
        const throttledResizeCallback = throttle(vm.handleResize, 250);
        window.addEventListener('resize', (event) => {
            if (event.isTrusted)
                throttledResizeCallback();
            if (!vm.isTouch && vm.miw(960)) {
                window.onmousemove = mouseMoveAndMouseUpHandler;
                window.onmouseup = mouseMoveAndMouseUpHandler;
            }
            else {
                window.onmousemove = null;
                window.onmouseup = null;
                this.handleClickOutside();
            }
        });
        vm.isInited = true;
        vm.init();
        throttledResizeCallback();
    },
    components: {
        ahead,
        leverageItem,
        VueSlider,
        multiSettingLeverages,
        ReqAfterKyc
    }
});
